/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum PdPainScaleAliases {
  BODY_LANGUAGE_FIELD = 'body-language-field',
  BODY_LANGUAGE_FORM = 'body-language-form',
  BODY_LANGUAGE_RADIO_GROUP = 'body-language-radio-group',
  BODY_LANGUAGE_TEXT = 'body-language-text',
  COMFORT_FIELD = 'comfort-field',
  COMFORT_FORM = 'comfort-form',
  COMFORT_RADIO_GROUP = 'comfort-radio-group',
  COMFORT_TEXT = 'comfort-text',
  FACIAL_EXPRESSION_FIELD = 'facial-expression-field',
  FACIAL_EXPRESSION_FORM = 'facial-expression-form',
  FACIAL_EXPRESSION_RADIO_GROUP = 'facial-expression-radio-group',
  FACIAL_EXPRESSION_TEXT = 'facial-expression-text',
  MODAL_PAIN_SCALE_REFERENCE = 'modal-pain-scale-reference',
  NEGATIVE_VOCALIZATION_FIELD = 'negative-vocalization-field',
  NEGATIVE_VOCALIZATION_FORM = 'negative-vocalization-form',
  NEGATIVE_VOCALIZATION_RADIO_GROUP = 'negative-vocalization-radio-group',
  NEGATIVE_VOCALIZATION_TEXT = 'negative-vocalization-text',
  PD_PAIN_SCALE_CONTEXTUAL_BAR = 'pd-pain-scale-contextualBar',
  PD_PAIN_SCALE_LAYOUT = 'pd-pain-scale-layout',
  PD_PAIN_SCALE_PANEL = 'pd-pain-scale-panel',
  REFERENCE_LINK = 'reference-link',
  REFERENCE_MODAL = 'reference-modal',
  REFERENCE_PANEL = 'reference-panel',
  TEXT_PAIN_SCALE_FIELD_REFERENCE = 'text-pain-scale-field-reference',
  VIB_FIELD = 'vib-field',
  VIB_FORM = 'vib-form',
  VIB_RADIO_GROUP = 'vib-radio-group',
  VIB_TEXT = 'vib-text',
}
export { PdPainScaleAliases };
